export default __webpack_public_path__ + "51878359fc5e314478f57607800eb71a.svg";